export const COMPILED_CONTRACTS_FILE_NAME = 'serverless-contracts.json';
export const LATEST_DEPLOYED_TIMESTAMP_TAG_NAME = 'LATEST_DEPLOYED_TIMESTAMP';
export const CONTRACTS_VERSION = '1.0.0';
